<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="itemValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.title')"
                :placeholder="$t('common.title')"
                v-model="value.title"
                name="title"
                :error="errors.get('title')">
            </base-input>

            <label class="form-control-label">Flights</label>

            <div class="row mb-3">
                <div class="col-2">
                    <base-input class="mb-3"
                        v-model="value.flights[0]">
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input class="mb-3"
                        v-model="value.flights[1]">
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input class="mb-3"
                        v-model="value.flights[2]">
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input class="mb-3"
                        v-model="value.flights[3]">
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input class="mb-3"
                        v-model="value.flights[4]">
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input class="mb-3"
                        v-model="value.flights[5]">
                    </base-input>
                </div>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? (duplicating ? $t('common.duplicate') : $t('common.update')) : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },
            
            modal: {
                type: Object,
                default: null
            },

            duplicating: {
                type: Boolean,
                default: false
            },

            degree: {
                type: Object,
                required: true
            },
        },

        created() {
            this.errors.setValidator('itemValidator', this)
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
